import { Data } from "./types";

import { HeadCell } from "@/components/app/EnhancedTableHeader/type";

const headCells: HeadCell<Data>[] = [
    {
        id: "id",
        numeric: true,
        disablePadding: true,
        label: "ID",
    },
    {
        id: "thumbnailPortrait",
        numeric: false,
        disablePadding: true,
        label: "Thumbnail",
    },
    {
        id: "en_title",
        numeric: false,
        disablePadding: true,
        label: "English Name",
    },
    {
        id: "ar_title",
        numeric: false,
        disablePadding: true,
        label: "Arabic Name",
    },
    {
        id: "typeId",
        numeric: false,
        disablePadding: true,
        label: "Type",
    },
    {
        id: "category",
        numeric: false,
        disablePadding: true,
        label: "Category",
    },
    {
        id: "updated_at",
        numeric: false,
        disablePadding: true,
        label: "Updated At",
    },
];

export default headCells;
